
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayStackedClosedBottom as ObiThreewayStackedClosedBottomElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-stacked-closed-bottom.js';
 
 
 

 
 export const ObiThreewayStackedClosedBottom = createComponent({
   react: React,
   tagName: 'obi-threeway-stacked-closed-bottom',
   elementClass: ObiThreewayStackedClosedBottomElement,
   events: {
     
   }
  });
 
 